<!--  -->
<template>
  <div>
    <el-form
      :model="formInline"
      class="demo-form-inline"
    >
      <el-form-item label="广告id">
        <el-button
          type="success"
          size="mini"
          @click="bandwechat"
        >选择</el-button>
        <div style="width: 580px; max-height: 300px; overflow: auto;">
          <el-tag
            v-for="itemr,index in arrs"
            :key="index"
            style="margin-right:10px;margin-bottom:5px"
            closable
            :type="itemr.type"
            @close="rightclick(itemr.id,index)"
          >
            {{ itemr.advertiser_name }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="formInline.remark"
          placeholder="请输入内容"
        />
      </el-form-item>
      <!-- <el-form-item label="后缀数字">
        <el-input-number v-model="formInline.suffix" :min="1" :max="1000" label="请输入内容" />
      </el-form-item> -->
      <el-form-item>
        <el-button
          type="danger"
          @click="arrs=[]"
        >一键清空</el-button>
        <el-button
          type="primary"
          @click="onSubmit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择广告主"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <choosepeol
        ref="choosepeolview"
        @bandarr="bandarr"
      />
    </el-dialog>
  </div>
</template>

<script>
import { advertiserchangeremark } from '@/api/report/accountManagement'
import choosepeol from './choosepeol.vue'
export default {
  components: { choosepeol },
  data() {
    return {
      formInline: {
        account_ids: [],
        remark: '',
        suffix: 1
      },
      dialogVisibler: false,
      arrs: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    onSubmit() {
      if (this.arrs.length === 0) return this.$message('请选择广告主')
      if (this.formInline.remark === '') return this.$message('请输入备注')
      // if (this.formInline.suffix === '') return this.$message('请输入后缀数字')
      // if (this.formInline.suffix === undefined) return this.$message('请输入后缀数字')
      this.formInline.account_ids = []
      this.formInline.account_ids = this.arrs.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
        return itemr.account_id
      })
      advertiserchangeremark({
        account_ids: this.formInline.account_ids,
        remark: this.formInline.remark
        // suffix: this.formInline.suffix
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('companycallback')
      })
    },
    sendr() {},
    async bandarr(arr) {
      console.log('66666', arr)
      this.dialogVisibler = false
      this.arrs = arr
      // this.formInline.account_ids = []
      // arr.forEach(element => {
      //   this.formInline.account_ids.push(element.account_id)
      // })
    },
    rightclick(id, index) {
      console.log(id, index)
      this.arrs.splice(index, 1)
    },
    bandwechat() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.choosepeolview.sendr(this.arrs)
      })
    },
    rightclick2(index) {
      this.merchant_ids.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
